import { useState, useEffect } from 'react';

// Si VITE_API_URL está definido, lo usa. Si no, usa cadena vacía para Vercel/proxies
const API_BASE = import.meta.env.VITE_API_URL || '';

export function useGlossaryData() {
  const [words, setWords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    async function fetchWords() {
      try {
        const token = localStorage.getItem('token');
        const headers = token ? { Authorization: `Bearer ${token}` } : {};

        // 🚀 APUNTAMOS A LA RUTA EXACTA: /api/glossary/all
        const cleanBase = API_BASE.replace(/\/api\/v1\/?/gi, '').replace(/\/$/, '');
        const endpoint = `${cleanBase}/api/glossary/all`;
        const res = await fetch(endpoint, { headers });

        // 🛡️ ESCUDO: Si el backend nos manda HTML (Error 404) en lugar de JSON
        const contentType = res.headers.get("content-type");
        if (!contentType || !contentType.includes("application/json")) {
          throw new Error(`La API no devolvió JSON. Verifica que el backend esté corriendo y la ruta ${endpoint} exista.`);
        }

        if (!res.ok) {
          throw new Error(`Error del servidor: ${res.status}`);
        }

        const data = await res.json();
        if (!cancelled) setWords(data);
      } catch (err) {
        if (!cancelled) setError(err.message);
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    fetchWords();
    return () => { cancelled = true; };
  }, []);

  return { words, loading, error };
}